// PART 1 OF 3 - IMPORTS AND LOGIC
// Copy this entire section first

import React, { useState, useContext, useEffect } from "react";
import topnavStyles from "./TopNav.module.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Form from "react-bootstrap/Form";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Link, useNavigate } from "react-router-dom";
import { CartContext } from "../../context/CartContext";
import axios from "axios";

const TopNav = () => {
  const navigate = useNavigate();
  const [topText, setTopText] = useState(true);

  const handleTopText = () => {
    const timer = setTimeout(() => {
      setTopText(!topText);
    }, 500);
    return () => clearTimeout(timer);
  };

  const [show, setShow] = useState(false);
  const [showMobileSearch, setShowMobileSearch] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [results, setResults] = useState([]);
  const [showResults, setShowResults] = useState(false);
  
  // NEW: Categories state
  const [categories, setCategories] = useState([]);
  const [showCategoriesDropdown, setShowCategoriesDropdown] = useState(false);
  const [expandedCategories, setExpandedCategories] = useState({});

  // NEW: Fetch categories on component mount
  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE}category/getCategories`);
      console.log("API Response:", res.data); // DEBUG: Check what we're getting
      // Fix: Extract categories from the response object
      const categoriesData = res.data.categories || res.data || [];
      console.log("Categories Array:", categoriesData); // DEBUG: Check the array
      setCategories(categoriesData);
    } catch (err) {
      console.error("Error fetching categories:", err);
    }
  };

  // NEW: Build category tree
  const buildCategoryTree = (categories) => {
    // Safety check: ensure categories is an array
    if (!Array.isArray(categories) || categories.length === 0) {
      return [];
    }
    
    const categoryMap = {};
    const tree = [];
    categories.forEach((cat) => {
      categoryMap[cat._id] = { ...cat, children: [] };
    });
    categories.forEach((cat) => {
      if (cat.parentId && categoryMap[cat.parentId]) {
        categoryMap[cat.parentId].children.push(categoryMap[cat._id]);
      } else {
        tree.push(categoryMap[cat._id]);
      }
    });
    return tree;
  };

  const categoryTree = buildCategoryTree(categories);

  const handleCategoryClick = (categoryName) => {
    navigate(`/shop?category=${encodeURIComponent(categoryName)}`);
    setShowCategoriesDropdown(false);
    setShow(false);
  };

  const toggleCategoryExpand = (categoryId) => {
    setExpandedCategories((prev) => ({
      ...prev,
      [categoryId]: !prev[categoryId],
    }));
  };

  // NEW: Recursive component to render category tree
  const CategoryTreeItem = ({ category, level = 0 }) => {
    const hasChildren = category.children && category.children.length > 0;
    const isExpanded = expandedCategories[category._id];
    
    return (
      <div>
        <div 
          className="d-flex align-items-center justify-content-between py-2 px-3" 
          style={{ 
            paddingLeft: `${level * 20 + 12}px`, 
            cursor: "pointer", 
            transition: "background-color 0.2s" 
          }} 
          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#f8f9fa"; }} 
          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "transparent"; }}
        >
          <span onClick={() => handleCategoryClick(category.Name)} style={{ flex: 1 }}>
            {category.Name}
          </span>
          {hasChildren && (
            <span 
              onClick={(e) => { e.stopPropagation(); toggleCategoryExpand(category._id); }} 
              style={{ fontSize: "12px", padding: "0 8px" }}
            >
              {isExpanded ? "−" : "+"}
            </span>
          )}
        </div>
        {hasChildren && isExpanded && (
          <div>
            {category.children.map((child) => (
              <CategoryTreeItem key={child._id} category={child} level={level + 1} />
            ))}
          </div>
        )}
      </div>
    );
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!searchTerm.trim()) return;
    try {
      navigate(`/shop?search=${encodeURIComponent(searchTerm.trim())}`);
      setSearchTerm("");
      setResults([]);
      setShowResults(false);
      setShowMobileSearch(false);
    } catch (err) {
      console.error("Search error:", err);
    }
  };

  const handleSearchInput = async (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    if (value.trim().length > 2) {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_BASE}product/search?`, { 
          params: { q: value.trim() } 
        });
        setResults(res.data.slice(0, 5));
        setShowResults(true);
      } catch (err) {
        console.error("Search suggestions error:", err);
        setResults([]);
        setShowResults(false);
      }
    } else {
      setResults([]);
      setShowResults(false);
    }
  };

  const handleSuggestionClick = (product) => {
    navigate(`/shop/product/${product._id}`);
    setSearchTerm("");
    setResults([]);
    setShowResults(false);
    setShowMobileSearch(false);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch(e);
    }
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  
  const { cart } = useContext(CartContext);
  const totalQty = cart.reduce((acc, product) => acc + product.quantity, 0);

  console.log(totalQty);
  return (
    <div className="fixed-top">
      <Container fluid className="px-0 mx-0 overflow-hidden"></Container>
      <Navbar expand="lg" className="bg-white py-4">
        <Container fluid className={topnavStyles.navcontainer}>
          <div className="d-flex align-items-baseline justify-content-between d-lg-none w-100">
            <div className="d-lg-none d-block">
              <span className="me-3">
                <svg
                  onClick={handleShow}
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21.375 12C21.375 12.2984 21.2565 12.5845 21.0455 12.7955C20.8345 13.0065 20.5484 13.125 20.25 13.125H3.75C3.45163 13.125 3.16548 13.0065 2.9545 12.7955C2.74353 12.5845 2.625 12.2984 2.625 12C2.625 11.7016 2.74353 11.4155 2.9545 11.2045C3.16548 10.9935 3.45163 10.875 3.75 10.875H20.25C20.5484 10.875 20.8345 10.9935 21.0455 11.2045C21.2565 11.4155 21.375 11.7016 21.375 12ZM3.75 7.125H20.25C20.5484 7.125 20.8345 7.00647 21.0455 6.7955C21.2565 6.58452 21.375 6.29837 21.375 6C21.375 5.70163 21.2565 5.41548 21.0455 5.2045C20.8345 4.99353 20.5484 4.875 20.25 4.875H3.75C3.45163 4.875 3.16548 4.99353 2.9545 5.2045C2.74353 5.41548 2.625 5.70163 2.625 6C2.625 6.29837 2.74353 6.58452 2.9545 6.7955C3.16548 7.00647 3.45163 7.125 3.75 7.125ZM20.25 16.875H3.75C3.45163 16.875 3.16548 16.9935 2.9545 17.2045C2.74353 17.4155 2.625 17.7016 2.625 18C2.625 18.2984 2.74353 18.5845 2.9545 18.7955C3.16548 19.0065 3.45163 19.125 3.75 19.125H20.25C20.5484 19.125 20.8345 19.0065 21.0455 18.7955C21.2565 18.5845 21.375 18.2984 21.375 18C21.375 17.7016 21.2565 17.4155 21.0455 17.2045C20.8345 16.9935 20.5484 16.875 20.25 16.875Z"
                    fill="black"
                  />
                </svg>
              </span>
              <Navbar.Brand href="#home" className="d-lg-none d-inline-block">
                <Link to="/"></Link>
              </Navbar.Brand>
            </div>
            <div className="d-lg-none d-block">
              <span className="me-3">
                <svg
                  onClick={() => setShowMobileSearch(true)}
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ cursor: "pointer" }}
                >
                  <path
                    d="M21.7959 20.2041L17.3437 15.75C18.6787 14.0104 19.3019 11.8282 19.087 9.64607C18.8722 7.4639 17.8353 5.44516 16.1867 3.99937C14.5382 2.55357 12.4014 1.78899 10.2098 1.86071C8.01829 1.93244 5.93607 2.8351 4.38558 4.38559C2.83509 5.93608 1.93243 8.0183 1.8607 10.2098C1.78898 12.4014 2.55356 14.5382 3.99936 16.1867C5.44515 17.8353 7.46389 18.8722 9.64606 19.087C11.8282 19.3019 14.0104 18.6787 15.75 17.3438L20.2059 21.8006C20.3106 21.9053 20.4348 21.9883 20.5715 22.0449C20.7083 22.1016 20.8548 22.1307 21.0028 22.1307C21.1508 22.1307 21.2973 22.1016 21.4341 22.0449C21.5708 21.9883 21.695 21.9053 21.7997 21.8006C21.9043 21.696 21.9873 21.5717 22.044 21.435C22.1006 21.2983 22.1298 21.1517 22.1298 21.0037C22.1298 20.8558 22.1006 20.7092 22.044 20.5725C21.9873 20.4358 21.9043 20.3115 21.7997 20.2069L21.7959 20.2041ZM4.12499 10.5C4.12499 9.23915 4.49888 8.0066 5.19938 6.95824C5.89987 5.90988 6.89551 5.09278 8.06039 4.61027C9.22527 4.12776 10.5071 4.00151 11.7437 4.2475C12.9803 4.49348 14.1162 5.10064 15.0078 5.9922C15.8994 6.88376 16.5065 8.01967 16.7525 9.2563C16.9985 10.4929 16.8722 11.7747 16.3897 12.9396C15.9072 14.1045 15.0901 15.1001 14.0418 15.8006C12.9934 16.5011 11.7608 16.875 10.5 16.875C8.80977 16.8733 7.18927 16.2011 5.99411 15.0059C4.79894 13.8107 4.12673 12.1902 4.12499 10.5Z"
                    fill="black"
                  />
                </svg>
              </span>
              <span className="me-3">
                <Link to="/cart">
                  <span className="position-relative">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.375 20.25C9.375 20.6208 9.26503 20.9834 9.059 21.2917C8.85298 21.6 8.56014 21.8404 8.21753 21.9823C7.87492 22.1242 7.49792 22.1613 7.1342 22.089C6.77049 22.0166 6.4364 21.838 6.17417 21.5758C5.91195 21.3136 5.73337 20.9795 5.66103 20.6158C5.58868 20.2521 5.62581 19.8751 5.76773 19.5325C5.90964 19.1899 6.14996 18.897 6.45831 18.691C6.76665 18.485 7.12916 18.375 7.5 18.375C7.99728 18.375 8.47419 18.5725 8.82582 18.9242C9.17745 19.2758 9.375 19.7527 9.375 20.25ZM17.25 18.375C16.8792 18.375 16.5166 18.485 16.2083 18.691C15.9 18.897 15.6596 19.1899 15.5177 19.5325C15.3758 19.8751 15.3387 20.2521 15.411 20.6158C15.4834 20.9795 15.662 21.3136 15.9242 21.5758C16.1864 21.838 16.5205 22.0166 16.8842 22.089C17.2479 22.1613 17.6249 22.1242 17.9675 21.9823C18.3101 21.8404 18.603 21.6 18.809 21.2917C19.015 20.9834 19.125 20.6208 19.125 20.25C19.125 19.7527 18.9275 19.2758 18.5758 18.9242C18.2242 18.5725 17.7473 18.375 17.25 18.375ZM22.0753 7.08094L19.5169 15.3966C19.3535 15.9343 19.0211 16.4051 18.569 16.739C18.1169 17.0729 17.5692 17.2521 17.0072 17.25H7.77469C7.2046 17.2482 6.65046 17.0616 6.1953 16.7183C5.74015 16.3751 5.40848 15.8936 5.25 15.3459L2.04469 4.125H1.125C0.826631 4.125 0.540483 4.00647 0.329505 3.7955C0.118526 3.58452 0 3.29837 0 3C0 2.70163 0.118526 2.41548 0.329505 2.2045C0.540483 1.99353 0.826631 1.875 1.125 1.875H2.32687C2.73407 1.87626 3.12988 2.00951 3.45493 2.25478C3.77998 2.50004 4.01674 2.84409 4.12969 3.23531L4.81312 5.625H21C21.1761 5.62499 21.3497 5.6663 21.5069 5.74561C21.664 5.82492 21.8004 5.94001 21.905 6.08164C22.0096 6.22326 22.0795 6.38746 22.1091 6.56102C22.1387 6.73458 22.1271 6.91266 22.0753 7.08094ZM19.4766 7.875H5.45531L7.41375 14.7281C7.43617 14.8065 7.48354 14.8755 7.54867 14.9245C7.6138 14.9736 7.69315 15.0001 7.77469 15H17.0072C17.0875 15.0002 17.1656 14.9746 17.2303 14.927C17.2949 14.8794 17.3426 14.8123 17.3662 14.7356L19.4766 7.875Z"
                        fill="black"
                      />
                    </svg>
                    {totalQty > 0 ? (
                      <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill text-bg-dark">
                        {totalQty}
                      </span>
                    ) : (
                      ""
                    )}
                  </span>
                </Link>
              </span>
            </div>

            {/* Mobile Menu Offcanvas - WITH CATEGORIES */}
            <Offcanvas show={show} onHide={handleClose} className="w-75">
              <Offcanvas.Header closeButton>
                <Offcanvas.Title>
                  <Link to="/">
                    <img
                      src="/blinq-logojpg.png"
                      alt="Logo"
                      width="125"
                      height="50"
                    />
                  </Link>
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <ul className="list-unstyled">
                  <li className="py-2">
                    <Link to="/" className="text-decoration-none text-dark">
                      Home
                    </Link>
                  </li>
                  <li className="py-2">
                    <div
                      className="text-decoration-none text-dark d-flex justify-content-between align-items-center"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        setShowCategoriesDropdown(!showCategoriesDropdown)
                      }
                    >
                      <span>Shop</span>
                      <span style={{ fontSize: "12px" }}>
                        {showCategoriesDropdown ? "−" : "+"}
                      </span>
                    </div>
                    {showCategoriesDropdown && (
                      <div className="mt-2 ms-3">
                        <div
                          className="py-2"
                          onClick={() => {
                            navigate("/shop");
                            setShow(false);
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          All Products
                        </div>
                        {categoryTree.map((category) => (
                          <CategoryTreeItem
                            key={category._id}
                            category={category}
                          />
                        ))}
                      </div>
                    )}
                  </li>
                </ul>
              </Offcanvas.Body>
            </Offcanvas>

            {/* Mobile Search Offcanvas */}
            <Offcanvas 
              show={showMobileSearch} 
              onHide={() => {
                setShowMobileSearch(false);
                setSearchTerm("");
                setResults([]);
                setShowResults(false);
              }} 
              placement="top"
              className="h-auto"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title>Search Products</Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Form onSubmit={handleSearch} className="position-relative">
                  <Form.Control
                    type="search"
                    placeholder="Search for products..."
                    className="mb-3"
                    aria-label="Search"
                    value={searchTerm}
                    onChange={handleSearchInput}
                    onKeyPress={handleKeyPress}
                    autoFocus
                  />

                  {showResults && results.length > 0 && (
                    <div className="border rounded shadow-sm">
                      {results.map((product) => (
                        <div
                          key={product._id}
                          className="p-2 border-bottom d-flex align-items-center"
                          onClick={() => handleSuggestionClick(product)}
                          style={{ cursor: "pointer" }}
                        >
                          <img
                            src={
                              Array.isArray(product.image_link) &&
                              product.image_link.length > 0
                                ? product.image_link[0]
                                : "https://via.placeholder.com/40"
                            }
                            alt={product.Title || "product"}
                            style={{
                              width: "40px",
                              height: "40px",
                              objectFit: "contain",
                              marginRight: "10px",
                            }}
                            onError={(e) => {
                              if (!e.target.dataset.failed) {
                                e.target.src = "https://via.placeholder.com/40";
                                e.target.dataset.failed = "true";
                              }
                            }}
                          />
                          <div>
                            <div style={{ fontSize: "14px", fontWeight: "500" }}>
                              {product.Title}
                            </div>
                            <div
                              style={{ fontSize: "12px", color: "rgba(0,0,0,0.6)" }}
                            >
                              ${product.price?.toFixed(2) || "0.00"}
                            </div>
                          </div>
                        </div>
                      ))}
                      <div
                        className="p-2 text-center text-primary"
                        style={{ fontSize: "12px", cursor: "pointer" }}
                        onClick={() => {
                          if (searchTerm.trim()) {
                            handleSearch({ preventDefault: () => {} });
                          }
                        }}
                      >
                        View all results for "{searchTerm}"
                      </div>
                    </div>
                  )}
                </Form>
              </Offcanvas.Body>
            </Offcanvas>
          </div>
          {/*logo */}
          <Navbar.Brand href="#home" className="me-lg-5 d-lg-block d-none">
            <Link to="/">
              <img
                src="/blinq-logojpg.png"
                alt="Logo"
                width="125"
                height="50"
              />
            </Link>
          </Navbar.Brand>
          
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto pt-2" id="nav-dropdown">
              <Link to="/" className="text-decoration-none fw-semibold">
                <Nav.Link href="/">Home</Nav.Link>
              </Link>
              
              {/* Desktop Shop with Categories Dropdown */}
              <div
                className="position-relative"
                onMouseEnter={() => setShowCategoriesDropdown(true)}
                onMouseLeave={() => setShowCategoriesDropdown(false)}
              >
                <Link to="/shop" className="text-decoration-none fw-semibold">
                  <Nav.Link href="/shop">Shop</Nav.Link>
                </Link>
                
                {showCategoriesDropdown && (
                  <div
                    className="position-absolute bg-white border rounded shadow-sm"
                    style={{
                      top: "100%",
                      left: "0",
                      zIndex: 1000,
                      minWidth: "250px",
                      maxHeight: "500px",
                      overflowY: "auto",
                    }}
                  >
                    <div
                      className="py-2 px-3"
                      onClick={() => {
                        navigate("/shop");
                        setShowCategoriesDropdown(false);
                      }}
                      style={{
                        cursor: "pointer",
                        fontWeight: "600",
                        borderBottom: "1px solid #dee2e6",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#f8f9fa";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "transparent";
                      }}
                    >
                      All Products
                    </div>
                    {categoryTree.map((category) => (
                      <CategoryTreeItem key={category._id} category={category} />
                    ))}
                  </div>
                )}
              </div>
            </Nav>
            
            <Form className="d-flex align-items-center position-relative">
              <Form.Control
                type="search"
                placeholder="Search"
                className={`${topnavStyles.navsearch} me-lg-5`}
                aria-label="Search"
                value={searchTerm}
                onChange={handleSearchInput}
                onKeyPress={handleKeyPress}
                onFocus={() => {
                  if (results.length > 0) {
                    setShowResults(true);
                  }
                }}
                onBlur={() => {
                  setTimeout(() => setShowResults(false), 200);
                }}
              />

              {/* Search suggestions dropdown */}
              {showResults && results.length > 0 && (
                <div
                  className="position-absolute bg-white border rounded shadow-sm w-100"
                  style={{
                    top: "100%",
                    left: "0",
                    zIndex: 1000,
                    maxHeight: "300px",
                    overflowY: "auto",
                  }}
                >
                  {results.map((product) => (
                    <div
                      key={product._id}
                      className="p-2 border-bottom cursor-pointer hover-bg-light d-flex align-items-center"
                      onClick={() => handleSuggestionClick(product)}
                      onMouseDown={(e) => e.preventDefault()}
                      style={{ cursor: "pointer" }}
                    >
                      <img
                        src={
                          Array.isArray(product.image_link) &&
                          product.image_link.length > 0
                            ? product.image_link[0]
                            : "https://via.placeholder.com/40"
                        }
                        alt={product.Title || "product"}
                        style={{
                          width: "40px",
                          height: "40px",
                          objectFit: "cover",
                          marginRight: "10px",
                        }}
                        onError={(e) => {
                          if (!e.target.dataset.failed) {
                            e.target.src = "https://via.placeholder.com/40";
                            e.target.dataset.failed = "true";
                          }
                        }}
                      />

                      <div>
                        <div style={{ fontSize: "14px", fontWeight: "500" }}>
                          {product.Title}
                        </div>
                        <div
                          style={{ fontSize: "12px", color: "rgba(0,0,0,0.6)" }}
                        >
                          ${product.price?.toFixed(2) || "0.00"}
                        </div>
                      </div>
                    </div>
                  ))}
                  <div
                    className="p-2 text-center text-primary"
                    style={{ fontSize: "12px", cursor: "pointer" }}
                    onClick={() => {
                      if (searchTerm.trim()) {
                        handleSearch({ preventDefault: () => {} });
                      }
                    }}
                    onMouseDown={(e) => e.preventDefault()}
                  >
                    View all results for "{searchTerm}"
                  </div>
                </div>
              )}

              <span className="me-lg-3">
                <Link to="/cart">
                  <span className="position-relative">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.375 20.25C9.375 20.6208 9.26503 20.9834 9.059 21.2917C8.85298 21.6 8.56014 21.8404 8.21753 21.9823C7.87492 22.1242 7.49792 22.1613 7.1342 22.089C6.77049 22.0166 6.4364 21.838 6.17417 21.5758C5.91195 21.3136 5.73337 20.9795 5.66103 20.6158C5.58868 20.2521 5.62581 19.8751 5.76773 19.5325C5.90964 19.1899 6.14996 18.897 6.45831 18.691C6.76665 18.485 7.12916 18.375 7.5 18.375C7.99728 18.375 8.47419 18.5725 8.82582 18.9242C9.17745 19.2758 9.375 19.7527 9.375 20.25ZM17.25 18.375C16.8792 18.375 16.5166 18.485 16.2083 18.691C15.9 18.897 15.6596 19.1899 15.5177 19.5325C15.3758 19.8751 15.3387 20.2521 15.411 20.6158C15.4834 20.9795 15.662 21.3136 15.9242 21.5758C16.1864 21.838 16.5205 22.0166 16.8842 22.089C17.2479 22.1613 17.6249 22.1242 17.9675 21.9823C18.3101 21.8404 18.603 21.6 18.809 21.2917C19.015 20.9834 19.125 20.6208 19.125 20.25C19.125 19.7527 18.9275 19.2758 18.5758 18.9242C18.2242 18.5725 17.7473 18.375 17.25 18.375ZM22.0753 7.08094L19.5169 15.3966C19.3535 15.9343 19.0211 16.4051 18.569 16.739C18.1169 17.0729 17.5692 17.2521 17.0072 17.25H7.77469C7.2046 17.2482 6.65046 17.0616 6.1953 16.7183C5.74015 16.3751 5.40848 15.8936 5.25 15.3459L2.04469 4.125H1.125C0.826631 4.125 0.540483 4.00647 0.329505 3.7955C0.118526 3.58452 0 3.29837 0 3C0 2.70163 0.118526 2.41548 0.329505 2.2045C0.540483 1.99353 0.826631 1.875 1.125 1.875H2.32687C2.73407 1.87626 3.12988 2.00951 3.45493 2.25478C3.77998 2.50004 4.01674 2.84409 4.12969 3.23531L4.81312 5.625H21C21.1761 5.62499 21.3497 5.6663 21.5069 5.74561C21.664 5.82492 21.8004 5.94001 21.905 6.08164C22.0096 6.22326 22.0795 6.38746 22.1091 6.56102C22.1387 6.73458 22.1271 6.91266 22.0753 7.08094ZM19.4766 7.875H5.45531L7.41375 14.7281C7.43617 14.8065 7.48354 14.8755 7.54867 14.9245C7.6138 14.9736 7.69315 15.0001 7.77469 15H17.0072C17.0875 15.0002 17.1656 14.9746 17.2303 14.927C17.2949 14.8794 17.3426 14.8123 17.3662 14.7356L19.4766 7.875Z"
                        fill="black"
                      />
                    </svg>
                    {totalQty > 0 ? (
                      <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill text-bg-dark">
                        {totalQty}
                      </span>
                    ) : (
                      ""
                    )}
                  </span>
                </Link>
              </span>
            </Form>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
};

export default TopNav;